import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ButtonPushComponent, TitleComponent } from "../../components";
import { ModalLayout } from "../../layouts";
import { requestPostAuthorization } from "../../services/requestPost";
import { clearUpdateComplement } from "../../store/complement";
import { ModalContainer } from "../ModalContainer/ModalContainer";

export const ProductComplementCreateHeaderContainer = () => {
  const [isOpenUpdate, setIsOpenUpdate] = useState(false);

  const complementData = useSelector((state) => state.retrieveComplement);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toggleModalUpdate = () => {
    setIsOpenUpdate(!isOpenUpdate);
  };
  const canceledStateStyle = {
    fontSize: "15px",
    fontWeight: "bold",
  };

  const convertMap = (array) => {
    return array.map((item) => item.id);
  };

  const handleCreateCombo = async () => {
    const body = { ...complementData };
    body.products && (body.products = convertMap(body.products));
    body.order ? (body.order = Number(body.order)) : (body.order = 0);
    await requestPostAuthorization(`admin/complementos/`, body).then(() => {
      dispatch(clearUpdateComplement());
      navigate("/productos/complementos");
    });
  };

  return (
    <section className="OrderDetailHeaderContainer">
      <div className="OrderDetailHeaderContainer__title">
        <TitleComponent title="Crear Complemento" />
      </div>
      <div className="OrderDetailHeaderContainer__container-button">
        <ButtonPushComponent name={"Crear Complemento"} onClick={toggleModalUpdate} />
      </div>
      {isOpenUpdate && (
        <ModalLayout>
          <ModalContainer
            title="Crear Complemento"
            msg="¿Está seguro que desea crear el Complemento?"
            style={canceledStateStyle}
            onClose={toggleModalUpdate}
            onConfirm={handleCreateCombo}
          />
        </ModalLayout>
      )}

      {/* {isLoading && (
        <ModalLayout>
          <LoadingComponent />
        </ModalLayout>
      )} */}
    </section>
  );
};
